export default __webpack_public_path__ + "static/media/globe-dark.0c895764.png";